<template lang="pug">
.crud
  modal-quotations-action-prop(:id="newRecord.id" :action="currentAction")
  modal-quotations-prop(:id="newRecord.id")
  modal-quotations-detail(:currency="newRecord.currency_id" :exchange_rate="parseFloat(newRecord.exchange_rate)" :detail='detail', :index='index', :is-add='isModalAdd')
  .container-fluid
    vm-row.heading(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        h2 {{ getTitle() }}: &nbsp;
        h2(v-if="!isAdd") {{ newRecord.folio }}
      vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
        div
          vm-button#saveRecord.vm-con-loading__container(icon="save-outline" :disabled="enabledSave" @click="saveRecord") {{ $t('strings.save') }}
          vm-tooltip(:text="$t('strings.options')" delay=".5s")
            vm-dropdown(vm-custom-content vm-trigger-click)
              vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

              vm-dropdown-menu
                vm-dropdown-item.d-flex.justify-content-between(@click="printRecord(newRecord)" :disabled="!enabledEdit")
                  vm-icon(icon="printer-outline")
                  slot &nbsp;{{ $t('strings.print') }}
                vm-dropdown-item.d-flex.justify-content-between(v-if="newRecord.status == '1'" @click="deleteQuotationConfirm(newRecord)" :disabled="!enabledEdit")
                  vm-icon(icon="trash-2-outline")
                  slot &nbsp;{{ $t('strings.delete') }}
                vm-dropdown-item.d-flex.justify-content-between(v-if="newRecord.status == '1'" @click="setActionQuotation(newRecord, 'sold')" :disabled="!enabledEdit")
                  vm-icon(icon="checkmark-circle-outline")
                  slot &nbsp;{{ $t('strings.accept') }}
                vm-dropdown-item.d-flex.justify-content-between(v-if="newRecord.status == '1'" @click="setActionQuotation(newRecord, 'cancelled')" :disabled="!enabledEdit")
                  vm-icon(icon="close-circle-outline")
                  slot &nbsp;{{ $t('strings.cancel') }}
                vm-dropdown-item.d-flex.justify-content-between(@click="setActionQuotationProp(newRecord, 'set-order')" :disabled="!enabledEdit")
                  vm-icon(icon="file-text-outline")
                  slot &nbsp;{{ $t('strings.purchase_order') }}
                //- More options
                    Agrega mas acciones para colecciones de datos
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-row.form(vm-align="center" vm-type="flex" vm-justify="flex-start" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=3)
            b-form-group
              vm-typeahead(url="customers" :label='$t("quotations.customer")' required :data="quotationsCatalog.customers" :placeholder='$t("quotations.customer_placeholder")' :danger="!$v.newRecord.customer_id.numeric" :danger-text="'Name must have at least 4 ' + $v.newRecord.customer_id.$params.numeric + ' letters.'" v-model="newRecord.customer_id" :filter="query => `?param=${query},tradename`"  :serializer="item => item.tradename" @input-change="autoCompleteFunc" :disabled="newRecord.status != '1'" :defaultValue="newRecord.customers && newRecord.customers.tradename ? newRecord.customers.tradename : ''")
                template(slot-scope="{data}")
                  vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
          vm-col(vm-justify="center", vm-align="center", vm-lg=3)
            b-form-group
              vm-select(:placeholder='$t("quotations.customer_contact_id_placeholder")' :warning="customerContacts.length == 0" warning-text="Este cliente no tiene contactos" v-model="newRecord.customer_contact_id" :label='$t("quotations.customer_contact_id")' :disabled="newRecord.status != '1' || customerContacts.length == 0")
                vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in customerContacts")
          vm-col(vm-justify="center", vm-align="center", vm-lg=3)
            b-form-group
              vm-input(:placeholder='$t("quotations.payment_conditions_placeholder")' v-model="newRecord.payment_conditions" :label='$t("quotations.payment_conditions")' :disabled="newRecord.status != '1'")
          vm-col(vm-justify="center", vm-align="center", vm-w=3)
            b-form-group
              vm-select(:placeholder="$t('strings.multiple')" label="Status" v-model="newRecord.status" disabled)
                vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
          vm-col(vm-justify="center", vm-align="center", vm-lg=3)
            b-form-group
              vm-date-picker(v-if='isAdd' type="date" :label="$t('quotations.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="newRecord.created_at" style="width=100%;" disabled)
              vm-date-picker(v-else type="date" :label="$t('quotations.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="newRecord.date_aux ? newRecord.date_aux : newRecord.created_at" style="width=100%;")
          vm-col(vm-justify="center", vm-align="center", vm-lg=3)
            b-form-group
              vm-select(:placeholder='$t("quotations.customer_address_id_placeholder")' :warning="customerAddresses.length == 0" warning-text="Este cliente no tiene direcciones" v-model="newRecord.customer_address_id" :label='$t("quotations.customer_address_id")' :disabled="newRecord.status != '1' || customerAddresses.length == 0")
                vm-select-item(:key="index" :value="item.id" :text="item.address_name" v-for="(item,index) in customerAddresses")
          vm-col(vm-justify="center", vm-align="center", vm-w=2)
            b-form-group
              label Tiempo de Entrega General
              vm-switch(v-model="newRecord.general_delivery_time_flag" :disabled="newRecord.status != '1'")
          vm-col(vm-justify="center", vm-align="center", vm-lg=2)
            b-form-group
              vm-input(:placeholder='$t("quotations.delivery_time_placeholder")' v-model="newRecord.delivery_time" :label='$t("quotations.delivery_time")' :disabled="newRecord.status != '1'" v-if="newRecord.general_delivery_time_flag" type="Number")
          vm-col(vm-justify="center", vm-align="center", vm-lg=2)
            b-form-group
              vm-select(:placeholder='$t("quotations.delivery_unit_placeholder")' v-model="newRecord.delivery_unit" :label='$t("quotations.delivery_unit")' :disabled="newRecord.status != '1'" v-if="newRecord.general_delivery_time_flag")
                vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in deliveryUnits")
          vm-col(vm-justify="center", vm-align="center", vm-lg=3, v-if='customerAddresses == 0')
            b-form-group
              vm-input(:placeholder='$t("quotations.delivery_address_placeholder")'  v-model="newRecord.delivery_address" :label='$t("quotations.delivery_address")' :disabled="newRecord.status != '1'")
          vm-col(vm-justify="center", vm-align="center", vm-lg=3)
            b-form-group
              vm-select(:placeholder='$t("quotations.currency_id_placeholder")' :danger="!$v.newRecord.currency_id.numeric" :danger-text="'Name must have at least 4 ' + $v.newRecord.currency_id.$params.numeric + ' letters.'" v-model="newRecord.currency_id" :label='$t("quotations.currency_id")' :disabled="newRecord.status != '1'")
                vm-select-item(:key="index" :value="item.id" :text="currencyText(item)" v-for="(item,index) in quotationsCatalog.currencies")
          vm-col(vm-justify="center", vm-align="center", vm-lg=2)
            b-form-group
              vm-input(:danger="!$v.newRecord.exchange_rate.minValue" danger-text="Establece un tipo de cambio" v-model="newRecord.exchange_rate" :label='$t("quotations.exchange_rate")' type="Number")
          vm-col.border(vm-justify="center", vm-align="center", vm-lg=4)
            vm-col(vm-justify="center", vm-align="center", vm-lg=6)
              b-form-group
                vm-input(:danger="!$v.newRecord.flete" :danger-text="'Is required'" v-model="newRecord.flete" :label='$t("quotations.flete")' :disabled="newRecord.status != '1'" type="Number")
            vm-col(vm-justify="center", vm-align="center", vm-lg=6)
              b-form-group
                label Prorateo de flete
                vm-switch(v-model="newRecord.type_fletes" :disabled="newRecord.status != '1'")
          vm-col(vm-justify="center", vm-align="center", vm-w=3)
            b-form-group
              vm-input(v-model="newRecord.discount" :label='$t("quotations.discount")' type="number" :disabled="newRecord.status != '1'" )
          vm-col(vm-justify="center", vm-align="center", vm-w=3)
            b-form-group
              label {{$t("quotations.comments")}}
              vm-textarea(v-model="newRecord.comments" counter="400" :disabled="newRecord.status != '1'")
          vm-col.border(vm-justify="center", vm-align="center", vm-lg=4)
            vm-col(vm-justify="center", vm-align="center", vm-w=6)
              b-form-group
                label Utilidad por PU
                vm-switch(v-model="newRecord.type_utility_calculation" :disabled="newRecord.status != '1'")
            vm-col(vm-justify="center", vm-align="center", vm-w=6)
              b-form-group
                label Utilidad General
                vm-switch(v-model="newRecord.type_utility" :disabled="newRecord.status != '1' || newRecord.type_utility_calculation")
          vm-col(vm-justify="center", vm-align="center", vm-w=3)
            b-form-group
              vm-input(v-if="newRecord.type_utility && !newRecord.type_utility_calculation" v-model="newRecord.utility" :label='$t("quotations_detail.utility")' type="number" icon-after="true" icon="percent-outline" :disabled="newRecord.status != '1'")
        vm-tabs
          vm-tab(vm-label="Details" vm-alignment="fixed")
            vm-table(multiple v-model="selected"  max-height="350px" :data="detailsList")
              template(slot="header")
                .d-flex.justify-content-between
                  div
                  div
                    vm-tooltip(:text="$t('strings.addDetail')" delay=".5s")
                      vm-button(size="small" icon="plus" @click="addQuotationDetail" :disabled="newRecord.status != '1'")
                    vm-tooltip(:text="$t('strings.delete')" delay=".5s")
                      vm-button(size="small" icon="trash-2-outline" @click="deleteQuotationDetailsConfirm" :disabled="newRecord.status != '1' || !enabledDelete")
              template(slot="thead")
                vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('quotations_detail.' + column) }}
                vm-th &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                    slot(v-if="column == 'total' || column == 'unit_price' || column == 'flete' || column == 'utility_amount' || column == 'utility_subtotal' || column == 'subtotal' || column == 'price'")  {{data[indextr][column] | currency }}
                    slot(v-if="column != 'status' && column != 'total' && column != 'unit_price' && column != 'product_id' && column != 'supplier_id' && column != 'utility' && column != 'individual_delivery_time' && column != 'flete' && column != 'utility_amount' && column != 'utility_subtotal' && column != 'subtotal' && column != 'price' && column != 'number_part' && column != 'pu' && column != 'pup'") {{data[indextr][column]}}
                    slot(v-if="column == 'status'") {{data[indextr]['status_display']}}
                    slot(v-if="column == 'product_id'") {{data[indextr]['product'].sku}} <br> {{data[indextr]['product'].name}}
                    slot(v-if="column == 'number_part'") {{data[indextr]['product'].number_part}}
                    slot(v-if="column == 'supplier_id'") {{data[indextr]['supplier'].name | truncate(15)}}
                    slot(v-if="column == 'utility' && newRecord.type_utility || column == 'utility' && newRecord.type_utility_calculation") {{data[indextr]['utility']}}
                    vm-input.blue-input(v-if="column == 'utility' && !newRecord.type_utility && !newRecord.type_utility_calculation" v-model="data[indextr]['utility']" type="number" icon-after="true" icon="percent-outline" style="width:130px;" :disabled="newRecord.status != '1'")
                    slot(v-if="column == 'individual_delivery_time' && newRecord.general_delivery_time_flag == true") {{ newRecord.delivery_time }}
                    //- slot(v-if="column == 'individual_delivery_time' && newRecord.general_delivery_time_flag == false && !isAdd") {{ data[indextr]['individual_delivery_time'] }}
                    vm-input(v-if="column == 'individual_delivery_time' && newRecord.general_delivery_time_flag == false" v-model="data[indextr]['individual_delivery_time']" style="width:100px;")
                    slot(v-if="column == 'pu' && !newRecord.type_utility_calculation") {{ parseFloat(data[indextr][column]) | currency }}
                    slot(v-if="column == 'pup'") {{ parseFloat(data[indextr][column]) | currency }}
                    slot(v-if="column == 'unit_measurement_display'") {{ data[indextr]['product'][column] }}
                    vm-input.blue-input(v-if="column == 'pu' && newRecord.type_utility_calculation" v-model="data[indextr]['price']" type="number" style="width:130px;" :disabled="newRecord.status != '1'" @keyup="checkPersonalUtility(indextr)" @keypress="checkPersonalUtility(indextr)")
                  vm-td
                    vm-dropdown(vm-custom-content vm-trigger-click :disabled="newRecord.status != '1'")
                      vm-button(type="flat" icon="more-horizotnal" color="#afbbc6" :disabled="newRecord.status != '1'")

                      vm-dropdown-menu
                        vm-dropdown-item.d-flex.justify-content-between(@click="editQuotationDetail(data[indextr], indextr)")
                          vm-icon(icon="edit-2-outline")
                          slot &nbsp;{{ $t('strings.edit') }}
                        vm-dropdown-item.d-flex.justify-content-between(@click="deleteQuotationDetailConfirm(data[indextr], indextr)")
                          vm-icon(icon="trash-2-outline")
                          slot &nbsp;{{ $t('strings.delete') }}
            vm-row(vm-align="flex-end" vm-type="flex" vm-justify="center" vm-w="12")
              b Total utilidad:&nbsp;&nbsp;
              span(style="font-size: 1.2rem;") {{ newRecord.utility_total | currency }}
            vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" vm-w="12")
              vm-col(vm-w=6)
                vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" style="text-align: right;")
                  vm-col(v-if="newRecord.type_fletes == false")
                    b Flete:&nbsp;&nbsp;
                    span(style="font-size: 1.4rem;") {{ newRecord.flete | currency }}
                vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" style="text-align: right;")
                  vm-col(v-if="newRecord.discount > 0")
                    b Descuento:&nbsp;&nbsp;
                    span(style="font-size: 1.4rem;" disabled) -{{ newRecord.discount | currency }}
                vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" style="text-align: right;")
                  vm-col
                    b Subtotal:&nbsp;&nbsp;
                    span(style="font-size: 1.4rem;") {{ newRecord.subtotal | currency }}
                vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" style="text-align: right;")
                  vm-col
                    vm-switch.tax-switch(v-model="newRecord.is_tax")
                    b &nbsp;&nbsp;Iva 16%:&nbsp;&nbsp;
                    span(style="font-size: 1.4rem;") {{ newRecord.sales_tax | currency }}
                vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" style="text-align: right;")
                  vm-col
                    b Total:&nbsp;&nbsp;
                    span(style="font-size: 1.4rem;") {{ newRecord.total | currency }}
              vm-row( style="text-align: left;" vm-w="12")
                vm-col
                  s {{$t('quotations_detail.last_update')}}:&nbsp;&nbsp;
                  span {{updatedAt}}
  transition(name="enter")
    .footer(v-if="enabledSave")
      vm-button(type="flat" text-color="#fff" color="rgb(190, 142, 241)" @click="cancel") {{ $t('strings.cancel') }}
      vm-button(type="default" @click="saveRecord") {{ $t('strings.save') }}
</template>

<script>
import ModalQuotationsDetail from '@/components/modals/ModalQuotationsDetail.vue'
import ModalQuotationsActionProp from '@/components/modals/ModalQuotationsActionProp.vue'
import ModalQuotationsProp from '@/components/modals/ModalQuotationsProp.vue'
import { required, numeric, minValue } from 'vuelidate/lib/validators' // Ver documentacion
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')

export default {
  name: 'QuotationsDetail',
  components: {
    ModalQuotationsDetail,
    ModalQuotationsActionProp,
    ModalQuotationsProp
  },
  props: {
    isAdd: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    newRecord: {
      status: 1,
      is_tax: true,
      general_delivery_time_flag: false,
      type_utility: false,
      type_utility_calculation: false,
      type_fletes: false,
      utility: 0,
      created_at: new Date(),
      updated_at: new Date(),
      date_aux: new Date(),
      flete: 0,
      pu: 0,
      currency_id: 2,
      exchange_rate: 1,
      discount: 0,
      comments: ' ',
      details: [],
      delivery_unit: 'days',
      subtotal: 0,
      total: 0
    },
    currentAction: '',
    isModalAdd: true,
    detail: {},
    index: 0,
    selected: [],
    holdSave: true,
    customerAddresses: [],
    customerContacts: [],
    columns: [
      'supplier_id',
      'individual_delivery_time',
      'quantity',
      'product_id',
      'number_part',
      'unit_price',
      'utility',
      'utility_amount',
      'utility_subtotal',
      'pu',
      'pup',
      'subtotal',
      'flete',
      'total',
      'unit_measurement_display'
    ],
    status: [
      {
        text: 'Pendiente',
        value: 1,
        color: 'primary'
      },
      {
        text: 'Pagado',
        value: 2,
        color: 'success'
      },
      {
        text: 'Cancelado',
        value: 3,
        color: 'danger'
      }
    ],
    deliveryUnits: [
      {
        text: 'Dias',
        value: 'days'
      },
      {
        text: 'Semanas',
        value: 'weeks'
      }
    ]
  }),
  validations: {
    newRecord: {
      customer_id: {
        required,
        numeric
      },
      currency_id: {
        required,
        numeric
      },
      flete: {
        required
      },
      exchange_rate: {
        required,
        minValue: minValue(0)
      }
    }
  },
  computed: {
    ...mapGetters([
      'quotation',
      'quotationsCatalog',
      'customer'
    ]),
    updatedAt () {
      return moment(this.newRecord.updated_at).format('DD/MM/yyyy hh:mm')
    },
    detailsList () {
      return this.newRecord.details.map((detail, index) => {
        this.priceDetailCalculation(detail)
        this.utilityDetailCalculation(detail, index)
        this.totalDetailCalculation(detail)
        this.subtotalCalculation()
        this.ivaCalculation()
        this.totalCalculation()
        return detail
      })
    },
    detailsLength () {
      return this.newRecord.details.length
    },
    hasDetails () {
      return this.newRecord.details.length > 0
    },
    enabledEdit () {
      return this.newRecord.id
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    enabledSave () {
      return !this.$v.newRecord.$invalid && this.hasDetails && this.holdSave && this.newRecord.status === 1
    }
  },
  watch: {
    quotation (quotation) {
      this.newRecord = parseVuexObject(quotation)
      // this.getCatalogAux()
    },
    'quotation.details' (details) {
      this.newRecord.details = parseVuexObject(details)
    },
    'newRecord.customer_id' (id) {
      if (this.isAdd) {
        var customer = this.quotationsCatalog.customers.find((customer) => customer.id === id)
        this.newRecord.payment_conditions = customer.payment_terms
        this.customerAddresses = customer.addresses
        this.customerContacts = customer.contacts
      } else {
        this.getCustomer({ id: id }).then(() => {
          this.newRecord.payment_conditions = this.customer.payment_terms
          this.customerAddresses = this.customer.addresses
          this.customerContacts = this.customer.contacts
        })
      }
    },
    'newRecord.currency_id' (id) {
      this.newRecord.exchange_rate = this.quotationsCatalog.currencies.find(currency => currency.id === id).exchange_rate
    }
  },
  async created () {
    this.initQuotation(this.newRecord)
    this.getCatalog()
    this.$route.params.id && await this.getQuotation()
  },
  methods: {
    ...mapActions([
      'initQuotation',
      'addQuotation',
      'editQuotation',
      'deleteQuotations',
      'deleteQuotationDetail',
      'deleteQuotationDetails',
      'actionQuotation',
      'loadQuotation',
      'loadCatalog',
      'loadCatalogAux',
      'setModalVisible',
      'setModalPropVisible',
      'setModalActionPropVisible',
      'getCustomer'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === code)['color']
    },
    getTitle () {
      return this.isAdd ? this.$t('quotations.add') : this.$t('quotations.edit')
    },
    addQuotationDetail () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.detail = {}
    },
    editQuotationDetail (detail, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.detail = { ...detail }
      this.index = index
    },
    async saveRecord () {
      if (!this.holdSave) return
      this.holdSave = false
      let t = this
      this.$vm.loading({
        background: 'primary',
        color: '#fff',
        container: '#saveRecord',
        scale: 0.45
      })
      this.newRecord.total = this.total
      this.newRecord.subtotal = this.subtotal
      this.newRecord.sales_tax = this.iva
      await this.isAdd ? this.addQuotation(this.newRecord).then((e) => { !e && t.$router.push({ name: 'quotations' }) }) : this.editQuotation(this.newRecord).then(() => { t.$router.push({ name: 'quotations' }) })
      setTimeout(() => {
        this.$vm.loading.close('#saveRecord > .con-vm-loading')
        this.holdSave = true
      }, 3000)
    },
    async deleteQuotationConfirm (quotation) {
      let t = this
      this.auxDeleteQuotation = () => {
        t.deleteQuotation(quotation).then(() => { t.$router.push({ name: 'quotations' }) })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.quotation'), attribute: this.$t(quotation.folio) }),
        accept: this.auxDeleteQuotation
      })
    },
    async deleteQuotationDetailConfirm (detail, index) {
      let t = this
      this.auxDeleteQuotationDetail = () => {
        t.deleteQuotationDetail({ detail, index }).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.quotation_detail'), attribute: detail.id ? detail.id : index }),
        accept: this.auxDeleteQuotationDetail
      })
    },
    async deleteQuotationDetailsConfirm () {
      let t = this
      let quotationsMany = parseDeleteMany(this.selected, 'index')
      this.auxDeleteQuotationDetail = () => {
        t.deleteQuotationDetails(quotationsMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.quotation_detail'), attribute: quotationsMany.values }),
        accept: this.auxDeleteQuotationDetail
      })
    },
    async setActionQuotation (record, action) {
      let t = this
      this.auxActionQuotation = () => {
        t.actionQuotation({ id: record.id, action })
      }
      this.$vm.dialog({
        color: 'warning',
        title: this.$t('strings.quotation'),
        text: this.$t('front.action_confirmation', { model: this.$t('strings.quotation'), action: this.$t('quotations.action_' + action) }),
        accept: this.auxActionQuotation
      })
    },
    setActionQuotationProp (record, action) {
      this.currentAction = action
      this.setModalActionPropVisible(true)
    },
    async getQuotation (page) {
      this.loadQuotation(this.$route.params)
    },
    async getCatalog () {
      Object.keys(this.quotationsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    getCatalogAux () {
      Object.keys(this.quotationsCatalog).forEach(e => {
        let arr = []
        Object.keys(this.newRecord).forEach(d => {
          if (e === d) {
            arr.push(parseVuexObject(this.newRecord[d]))
            this.loadCatalogAux({ url: e, data: arr })
          }
        })
        arr = []
        this.newRecord.details.map(d => {
          let dd = parseVuexObject(d)
          Object.keys(dd).forEach(f => {
            let concat = `${f}s`
            if (e === concat) {
              arr.push(dd[f])
              this.loadCatalogAux({ url: e, data: arr })
            }
          })
        })
      })
    },
    printRecord (record) {
      this.setModalPropVisible(true)
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      this.newRecord.date_aux = date
    },
    getFlete (value) {
      let subtotal = this.newRecord.details.reduce((prev, cur) => prev + parseFloat(cur.subtotal), 0).toFixed(2)
      let percent = (value * 100) / subtotal
      return ((percent * this.newRecord.flete) / 100).toFixed(2)
    },
    cancel () {
      this.$router.push({ name: 'quotations' })
    },
    currencyText (item) {
      return `${item.name} ${item.code}`
    },
    priceDetailCalculation (detail) {
      if (parseFloat(detail.unit_price_raw) === 0.00) { detail.unit_price_raw = detail.unit_price }
      let unitPriceMx = parseFloat(detail.unit_price_raw) * parseFloat(this.quotationsCatalog.currencies.find(e => e.id === detail.product.currency_id).exchange_rate).toFixed(5)
      parseFloat(detail.unit_price = parseFloat(parseFloat(unitPriceMx) / parseFloat(this.newRecord.exchange_rate)).toFixed(5))
    },
    utilityDetailCalculation (detail, index) {
      if (this.newRecord.type_utility) { detail.utility = parseFloat(this.newRecord.utility).toFixed(5) }
      if (this.newRecord.type_utility_calculation) {
        this.newRecord.type_utility = false
        detail.utility = parseFloat(100 * (1 - (detail.unit_price / detail.price))).toFixed(5)
      } else {
        detail.price = parseFloat(detail.unit_price / ((100 - parseFloat(detail.utility)) / 100)).toFixed(5)
      }
      detail.index = index
      detail.utility_amount = parseFloat(detail.price - detail.unit_price).toFixed(5)
      detail.utility_subtotal = (parseFloat(detail.quantity) * parseFloat(detail.utility_amount)).toFixed(5)
    },
    totalDetailCalculation (detail) {
      detail.subtotal = (parseFloat(detail.price) * parseFloat(detail.quantity)).toFixed(5)
      if (this.newRecord.type_fletes) {
        detail.flete = this.getFlete(detail.subtotal)
        detail.pu = parseFloat((parseFloat(detail.flete) / parseFloat(detail.quantity).toFixed(5)) + parseFloat(detail.price)).toFixed(4)
        detail.pup = parseFloat((parseFloat(detail.flete) / parseFloat(detail.quantity).toFixed(5)) + parseFloat(detail.price)).toFixed(4)
      } else {
        detail.flete = 0
        detail.pu = parseFloat(detail.price).toFixed(5)
        detail.pup = parseFloat(detail.price).toFixed(5)
      }
      detail.total = parseFloat(detail.subtotal) + parseFloat(detail.flete)
      this.newRecord.details_total = this.newRecord.details.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(5)
      this.newRecord.utility_total = this.newRecord.details.reduce((prev, cur) => prev + parseFloat(cur.utility_subtotal), 0).toFixed(5)
    },
    subtotalCalculation () {
      let flet = 0
      if (!this.newRecord.type_fletes && this.newRecord.flete !== 0) {
        flet = this.newRecord.flete
      }
      this.newRecord.subtotal = (parseFloat(flet) + parseFloat(this.newRecord.details_total) - this.newRecord.discount)
    },
    ivaCalculation () {
      let iva = 0
      this.newRecord.is_tax && (iva = (parseFloat(this.newRecord.subtotal)) * 0.16)
      this.newRecord.sales_tax = iva
    },
    totalCalculation () {
      this.newRecord.total = (parseFloat(this.newRecord.subtotal) + parseFloat(this.newRecord.sales_tax)).toFixed(5)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.form {
  padding: 20px 10px 0;
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.con-vm-tabs {
  padding: 10px;
  .vm-tabs--ul {
    box-shadow: none;
  }
  .vm-tabs--content {
    padding: 0;
  }
}
.vm-col {
  padding: 0 10px;
}
.vm-table--header {
  padding: 0px !important;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
          display: block;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-idblock;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
.tax-switch {
  display: inline-block;
  input {
    position: relative !important;
  }
}
.blue-input {
  border: 1px solid #0D4351;
  color: #0D4351;
}
.border {
  border: 1px solid #0D4351;
  border-radius: 5px;
}
</style>
